import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {connect} from 'react-redux';
import {Link, browserHistory} from 'react-router';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import {Request, GET, POST} from 'requests';
import {default as RequestsMixin, IS_QUEUED, HAS_NO_CONTENT, HAS_ERRORS, HAS_FAILED, IS_DONE} from 'requests/RequestsMixin';
import ResourcesMatching from 'requests/components/ResourcesMatching';
import Requesting from 'requests/components/Requesting';
import Done from 'requests/components/Done';
import MainNavMixin from '../mixins/MainNavMixin';

const POLL_KIT_INTERVAL = 5 * 1000;
const SHOULD_TAKE_LESS_THAN = 5;  // in minutes
const EXTRA_MINUTES = 5;
const POLL_KIT_TIMEOUT = (SHOULD_TAKE_LESS_THAN + EXTRA_MINUTES) * 60 * 1000;

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;
  const next = ownProps.location.query.next;

  return {
    kitToken,
    next,
    requests: state.requests,
  };
};

const MigrateController = createReactClass({
  propTypes: {
    kitToken: PropTypes.string.isRequired,
    next: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
  },

  mixins: [MainNavMixin, RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      migrating: false,
      beganPolling: null,
      hasFinished: false,
      hasFailedMigration: false,
      hasTimedOut: false,
    };
  },

  componentWillMount() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });
  },

  transitions(register) {
    const migration = {
      request: this.requests.migrateKit,
      from: IS_QUEUED,
      to: HAS_ERRORS,
      call(rm) {
        this.beginPolling();
      },
    };

    register(Object.assign({}, migration, {
      to: HAS_ERRORS,
    }));

    register(Object.assign({}, migration, {
      to: HAS_NO_CONTENT,
    }));

    register(Object.assign({}, migration, {
      to: HAS_FAILED,
      call(rm) {
        this.setState({
          hasFailedMigration: true,
        });
      },
    }));

    register({
      request: this.requests.kit,
      to: IS_DONE,
      call(rm) {
        const kit = rm.type(this.requests.kit, 'kits').get();

        if (kit.version === KIT_LATEST_VERSION) {  // eslint-disable-line no-undef
          browserHistory.push(`/kits/${this.props.kitToken}`);
        } else {
          this.startMigration();
        }

        this.setState({migrating: kit.migrating});
      },
    });

    register({
      request: this.requests.pollKit,
      to: IS_DONE,
      call(rm) {
        const {beganPolling} = this.state;
        const kit = rm.type(this.requests.kit, 'kits').get();
        const hasTimedOut = Date.now() - beganPolling > POLL_KIT_TIMEOUT;
        const kitAtLatestVersion = kit.version === KIT_LATEST_VERSION;  // eslint-disable-line no-undef

        let migrating = kit.migrating;

        if (!hasTimedOut && !kitAtLatestVersion) {
          setTimeout(this.poll, POLL_KIT_INTERVAL);
        }

        if (hasTimedOut) {
          migrating = false;
        }

        this.setState({migrating, hasFinished: kitAtLatestVersion, hasTimedOut});
      },
    });
  },

  startMigration() {
    this.setState({migrating: true});

    this.setRequest({
      migrateKit: new Request({
        method: POST,
        url: ['api', 'kits', this.props.kitToken, 'migrations'],
      }),
    });
  },

  beginPolling() {
    this.setState({
      beganPolling: Date.now(),
    });

    setTimeout(this.poll, POLL_KIT_INTERVAL);
  },

  poll() {
    this.setRequest({
      pollKit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
        useCache: false,
      }),
    });
  },

  renderMigrationPending() {
    const {migrating, hasTimedOut} = this.state;

    return (
      <div className="well bg-success-lightest p-xs-a-2x text-xs-center m-xs-b-0" role="alert">

        <div className="m-xs-b-lg">
          <h2 className="animated pulseOpacity text-success infinite m-xs-b-sm">
            <i className="ficon ficon-yoda ficon-4x m-xs-b-md block"></i>
            Patience. Maintaining your kit we are.
          </h2>

          <p className="text-xl font-weight-bold">Less than {SHOULD_TAKE_LESS_THAN} minutes to complete this should take.</p>
        </div>

        <div className="lead font-weight-normal">
          <p>We're updating some of your kit's behind-the-scenes technical details. None of your icons, typefaces, or images will be changed or published during this process.</p>
          <p>
              <span className="m-xs-r-xs">Taking far longer than expected?</span>
              <a href="mailto:help@fortawesome.com" className="text-danger">Let us know</a>
          </p>
        </div>
      </div>
    );
  },

  renderTimedOut() {
    return (
      <div className="well bg-danger-lightest p-xs-a-2x text-xs-center m-xs-b-0" role="alert">

        <div className="text-danger m-xs-b-lg ">
          <h2 className="m-xs-b-sm">
            <i className="ficon ficon-yoda ficon-4x m-xs-b-lg block"></i>
            Failed, we have.
          </h2>

          <p className="text-xl font-weight-bold">Update your kit we could not. Help you must seek.</p>
        </div>

        <div className="lead font-weight-normal">
          <p>
            <span className="m-xs-r-xs">We were not able to complete maintenance on your kit. Please</span>
            <a href="mailto:help@fortawesome.com" className="text-danger">Let us know</a>
            <span className="m-xs-l-xs">and we'll help get things back on track.</span>
          </p>
        </div>
      </div>
    );
  },

  renderMigrationFailed() {
    return (
      <div className="well bg-danger-lightest p-xs-a-2x text-xs-center m-xs-b-0" role="alert">
        <div className="text-danger m-xs-b-lg ">
          <h2 className="m-xs-b-sm">
            <i className="ficon ficon-yoda ficon-4x m-xs-b-lg block"></i>
            Failed, we have.
          </h2>

          <p className="text-xl font-weight-bold">Update your kit we could not. Help you must seek.</p>
        </div>

        <div className="lead font-weight-normal">
          <p>
            <span className="m-xs-r-xs">We were not able to complete maintenance on your kit. Please</span>
            <a href="mailto:help@fortawesome.com" className="text-danger">Let us know</a>
            <span className="m-xs-l-xs">and we'll help get things back on track.</span>
          </p>
        </div>
      </div>
    );
  },

  renderMigrationFinished() {
    return (
      <div className="well bg-success-lightest p-xs-a-2x text-xs-center m-xs-b-0" role="alert">

        <div className="m-xs-b-lg ">
          <h2 className="m-xs-b-sm text-success">
            <i className="ficon ficon-yoda ficon-4x m-xs-b-lg block"></i>
            Successful our mission was.
          </h2>
          <p className="text-xl font-weight-bold">For your patience we thank you.</p>
        </div>

        <p className="lead font-weight-normal">
          Your kit, and its contents have been polished and tuned to work with the latest and greatest Fort Awesome updates. Go ahead and jump back into making something awesome.
        </p>

        <a className="btn btn-primary-outline btn-lg" href={this.props.next || `/kits/${this.props.kitToken}`}>Okay, let's get back to work!</a>
      </div>
    );
  },

  renderMain() {
    const {
      kitToken,
    } = this.props;
    const {
      kit: kitRequest,
      subscription: subscriptionRequest,
    } = this.requests;

    const rm = this.resourceManager();
    const kit = rm.type(kitRequest, 'kits').find({token: kitToken});
    const subscription = rm.type(subscriptionRequest, 'subscriptions').get();
    const {hasFinished, hasTimedOut, hasFailedMigration} = this.state;

    let value = null;

    if (hasFinished) {
      value = this.renderMigrationFinished();
    }

    if (!hasFinished) {
      value = this.renderMigrationPending();
    }

    if (hasTimedOut) {
      value = this.renderTimedOut();
    }

    if (hasFailedMigration) {
      value = this.renderMigrationFailed();
    }

    return (
      <div className="well bg-white will-fill-page p-xs-a-lg">
        <div className="kit-summary gg gg-middle m-xs-b-sm">
          <h1 className="text-3x gg-col kit-title">
            <span>
              <Link className="link-dashed-none" to={`/kits/${kit.token}`}>
                {kit.name}
              </Link>
            </span>
          </h1>
        </div>
        {this.renderNav(kit, subscription, {disabled: true})}
        <div className="kit-components">
          {value}
        </div>
      </div>
    )
  },

  render() {
    const requests = [this.requests.kit, this.requests.subscription];

    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={requests}>
          <div className="well bg-white will-fill-page p-xs-a-lg is-loading">
            <Spinner size={SIZE_LARGE} />
          </div>
        </Requesting>
        <Done all={requests} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(MigrateController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/MigrateController.js